"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShiftedWeekdayChargeDate = exports.getNextRenewalDateAfterCharge = exports.getScheduledEndDate = exports.getLatestScheduledEndDate = exports.getScheduledEndCancelAt = exports.getLastChargeDateBefore = exports.getLastDayOfMonthChargeDate = exports.isLastDayOfMonthChargeDate = exports.offLastDayOfMonthChargeHour = exports.getFirstRenewalDateOnChargeDay = exports.getNormalFirstRenewalDate = exports.getDefaultChargeDay = exports.toChargeTimezoneDateTime = exports.atLastDayOfMonthChargeHour = exports.SUBSCRIPTION_PERIOD = exports.getDaysInMonth = exports.isChargeDayCustomizable = exports.isWeekBasedSubscriptionInterval = exports.isWeekdayChargeDay = exports.MAX_CHARGE_DAY_OF_MONTH = exports.LAST_DAY_OF_MONTH_CHARGE_HOUR_UTC = exports.LAST_DAY_OF_MONTH = void 0;
const luxon_1 = require("luxon");
const subscription_1 = require("../types/subscription");
exports.LAST_DAY_OF_MONTH = "last";
exports.LAST_DAY_OF_MONTH_CHARGE_HOUR_UTC = 12;
const FAR_EAST_LAST_DAY_OF_MONTH_CHARGE_HOUR_UTC = 6;
const FAR_EAST_OFFSET_MINUTES = 12 * 60;
exports.MAX_CHARGE_DAY_OF_MONTH = 28;
const isWeekdayChargeDay = (chargeDay) => "weekday" in chargeDay;
exports.isWeekdayChargeDay = isWeekdayChargeDay;
const isWeekBasedSubscriptionInterval = (recurrenceInterval) => recurrenceInterval === subscription_1.SubscriptionRecurrenceInterval.Weekly ||
    recurrenceInterval === subscription_1.SubscriptionRecurrenceInterval.BiWeekly;
exports.isWeekBasedSubscriptionInterval = isWeekBasedSubscriptionInterval;
const isChargeDayCustomizable = (recurrenceInterval) => recurrenceInterval === subscription_1.SubscriptionRecurrenceInterval.Monthly || (0, exports.isWeekBasedSubscriptionInterval)(recurrenceInterval);
exports.isChargeDayCustomizable = isChargeDayCustomizable;
const getDaysInMonth = (date) => date.daysInMonth ?? 31;
exports.getDaysInMonth = getDaysInMonth;
exports.SUBSCRIPTION_PERIOD = {
    [subscription_1.SubscriptionRecurrenceInterval.Weekly]: { weeks: 1 },
    [subscription_1.SubscriptionRecurrenceInterval.BiWeekly]: { weeks: 2 },
    [subscription_1.SubscriptionRecurrenceInterval.Monthly]: { months: 1 },
    [subscription_1.SubscriptionRecurrenceInterval.Quarterly]: { months: 3 },
    [subscription_1.SubscriptionRecurrenceInterval.Yearly]: { years: 1 },
};
const atLastDayOfMonthChargeHour = (date) => luxon_1.DateTime.utc(date.year, date.month, date.day, date.offset >= FAR_EAST_OFFSET_MINUTES
    ? FAR_EAST_LAST_DAY_OF_MONTH_CHARGE_HOUR_UTC
    : exports.LAST_DAY_OF_MONTH_CHARGE_HOUR_UTC);
exports.atLastDayOfMonthChargeHour = atLastDayOfMonthChargeHour;
const toChargeTimezoneDateTime = (date, timezone) => {
    const zoned = luxon_1.DateTime.fromJSDate(date, { zone: timezone || "utc" });
    return zoned.isValid ? zoned : luxon_1.DateTime.fromJSDate(date, { zone: "utc" });
};
exports.toChargeTimezoneDateTime = toChargeTimezoneDateTime;
const getDefaultChargeDay = ({ recurrenceInterval, timezone, now = new Date(), }) => {
    const today = (0, exports.toChargeTimezoneDateTime)(now, timezone);
    if ((0, exports.isWeekBasedSubscriptionInterval)(recurrenceInterval)) {
        return { weekday: today.weekday };
    }
    return { dayOfMonth: today.day > exports.MAX_CHARGE_DAY_OF_MONTH ? exports.LAST_DAY_OF_MONTH : today.day };
};
exports.getDefaultChargeDay = getDefaultChargeDay;
const getNormalFirstRenewalDate = ({ recurrenceInterval, timezone, now = new Date(), }) => (0, exports.toChargeTimezoneDateTime)(now, timezone).plus(exports.SUBSCRIPTION_PERIOD[recurrenceInterval]).toJSDate();
exports.getNormalFirstRenewalDate = getNormalFirstRenewalDate;
const getClosestWeekday = (normal, weekday) => {
    const forward = (weekday - normal.weekday + 7) % 7;
    return normal.plus({ days: forward > 3 ? forward - 7 : forward });
};
const getFirstRenewalDateOnChargeDay = ({ chargeDay, recurrenceInterval, timezone, now = new Date(), }) => {
    const isWeekBased = (0, exports.isWeekBasedSubscriptionInterval)(recurrenceInterval);
    if (!(0, exports.isChargeDayCustomizable)(recurrenceInterval) || (0, exports.isWeekdayChargeDay)(chargeDay) !== isWeekBased) {
        return null;
    }
    const checkout = (0, exports.toChargeTimezoneDateTime)(now, timezone);
    const normal = checkout.plus(exports.SUBSCRIPTION_PERIOD[recurrenceInterval]);
    if ((0, exports.isWeekdayChargeDay)(chargeDay)) {
        const firstRenewal = normal.plus({ days: chargeDay.weekday - normal.weekday });
        return firstRenewal.hasSame(normal, "day") ? null : firstRenewal.toJSDate();
    }
    const lastDay = (0, exports.getDaysInMonth)(normal);
    if (chargeDay.dayOfMonth === exports.LAST_DAY_OF_MONTH) {
        return (0, exports.atLastDayOfMonthChargeHour)(normal.set({ day: lastDay })).toJSDate();
    }
    const firstRenewal = (0, exports.offLastDayOfMonthChargeHour)(normal.set({ day: Math.min(chargeDay.dayOfMonth, lastDay) }));
    return chargeDay.dayOfMonth === checkout.day ? null : firstRenewal.toJSDate();
};
exports.getFirstRenewalDateOnChargeDay = getFirstRenewalDateOnChargeDay;
const isAtLastDayOfMonthChargeHour = (date) => {
    const utc = date.toUTC();
    return ([exports.LAST_DAY_OF_MONTH_CHARGE_HOUR_UTC, FAR_EAST_LAST_DAY_OF_MONTH_CHARGE_HOUR_UTC].includes(utc.hour) &&
        utc.minute === 0 &&
        utc.second === 0);
};
const offLastDayOfMonthChargeHour = (date) => isAtLastDayOfMonthChargeHour(date) ? date.plus({ minutes: 1 }) : date;
exports.offLastDayOfMonthChargeHour = offLastDayOfMonthChargeHour;
const isLastDayOfMonthChargeDate = (chargeDate) => {
    const date = luxon_1.DateTime.fromJSDate(chargeDate, { zone: "utc" });
    return date.day === (0, exports.getDaysInMonth)(date) && isAtLastDayOfMonthChargeHour(date);
};
exports.isLastDayOfMonthChargeDate = isLastDayOfMonthChargeDate;
const followMonthEndOfLastDayCharge = (date) => date.day >= exports.MAX_CHARGE_DAY_OF_MONTH && date.day < (0, exports.getDaysInMonth)(date) && isAtLastDayOfMonthChargeHour(date)
    ? date.set({ day: (0, exports.getDaysInMonth)(date) })
    : date;
const getLastDayOfMonthChargeDate = (nextChargeDate) => {
    const nextCharge = luxon_1.DateTime.fromJSDate(nextChargeDate, { zone: "utc" });
    const monthEnd = followMonthEndOfLastDayCharge(nextCharge);
    return monthEnd.equals(nextCharge) ? null : monthEnd.toJSDate();
};
exports.getLastDayOfMonthChargeDate = getLastDayOfMonthChargeDate;
const getRenewalAfter = (anchor, recurrenceInterval, count, billingAnchorDayOfMonth) => {
    const { weeks = 0, months = 0, years = 0 } = exports.SUBSCRIPTION_PERIOD[recurrenceInterval];
    const renewal = anchor.plus({ weeks: weeks * count, months: months * count, years: years * count });
    if (recurrenceInterval !== subscription_1.SubscriptionRecurrenceInterval.Monthly) {
        return renewal;
    }
    if ((0, exports.isLastDayOfMonthChargeDate)(anchor.toJSDate())) {
        return renewal.set({ day: (0, exports.getDaysInMonth)(renewal) });
    }
    return billingAnchorDayOfMonth && billingAnchorDayOfMonth > anchor.day
        ? renewal.set({ day: Math.min(billingAnchorDayOfMonth, (0, exports.getDaysInMonth)(renewal)) })
        : renewal;
};
const getChargesAroundEnd = ({ nextChargeDate, recurrenceInterval, endDate, billingAnchorDayOfMonth, }) => {
    const anchor = luxon_1.DateTime.fromJSDate(new Date(nextChargeDate), { zone: "utc" });
    const end = luxon_1.DateTime.fromJSDate(endDate, { zone: "utc" });
    if (anchor >= end) {
        return { lastCharge: null, firstDroppedCharge: anchor };
    }
    const { weeks = 0, months = 0, years = 0 } = exports.SUBSCRIPTION_PERIOD[recurrenceInterval];
    const elapsedPeriods = weeks
        ? end.diff(anchor, "weeks").weeks / weeks
        : months
            ? end.diff(anchor, "months").months / months
            : end.diff(anchor, "years").years / years;
    const renewalAfter = (count) => getRenewalAfter(anchor, recurrenceInterval, count, billingAnchorDayOfMonth);
    const walkToEnd = (lastCharge, count) => {
        const renewal = renewalAfter(count);
        return renewal >= end ? { lastCharge, firstDroppedCharge: renewal } : walkToEnd(renewal, count + 1);
    };
    const startCount = Math.max(Math.floor(elapsedPeriods) - 1, 0);
    return walkToEnd(renewalAfter(startCount), startCount + 1);
};
const getLastChargeDateBefore = (params) => getChargesAroundEnd(params).lastCharge?.toJSDate() ?? null;
exports.getLastChargeDateBefore = getLastChargeDateBefore;
const getScheduledEndCancelAt = (params) => getChargesAroundEnd(params).firstDroppedCharge.toJSDate();
exports.getScheduledEndCancelAt = getScheduledEndCancelAt;
const MAX_SCHEDULED_END_YEARS = 10;
const getLatestScheduledEndDate = (now = new Date()) => luxon_1.DateTime.fromJSDate(now, { zone: "utc" }).plus({ years: MAX_SCHEDULED_END_YEARS }).toISODate() ?? "";
exports.getLatestScheduledEndDate = getLatestScheduledEndDate;
const getScheduledEndDate = ({ endDate, timezone }) => {
    const zoned = luxon_1.DateTime.fromISO(endDate, { zone: timezone || "utc" });
    return (zoned.isValid ? zoned : luxon_1.DateTime.fromISO(endDate, { zone: "utc" })).startOf("day").toJSDate();
};
exports.getScheduledEndDate = getScheduledEndDate;
const getNextRenewalDateAfterCharge = ({ currentPeriodEnd, chargedAt, recurrenceInterval, }) => {
    const earliestNextRenewal = luxon_1.DateTime.fromJSDate(new Date(chargedAt), { zone: "utc" }).plus({ hours: 12 });
    const nextRenewal = advanceByPeriodWhile(luxon_1.DateTime.fromJSDate(new Date(currentPeriodEnd), { zone: "utc" }), exports.SUBSCRIPTION_PERIOD[recurrenceInterval], (renewal) => renewal < earliestNextRenewal);
    return (recurrenceInterval === subscription_1.SubscriptionRecurrenceInterval.Monthly
        ? followMonthEndOfLastDayCharge(nextRenewal)
        : nextRenewal).toJSDate();
};
exports.getNextRenewalDateAfterCharge = getNextRenewalDateAfterCharge;
const getShiftedWeekdayChargeDate = ({ currentNextChargeDate, weekday, recurrenceInterval, timezone, now = new Date(), }) => {
    const current = (0, exports.toChargeTimezoneDateTime)(new Date(currentNextChargeDate), timezone);
    return advanceByPeriodWhile(getClosestWeekday(current, weekday), exports.SUBSCRIPTION_PERIOD[recurrenceInterval], (shifted) => shifted.toMillis() <= now.getTime()).toJSDate();
};
exports.getShiftedWeekdayChargeDate = getShiftedWeekdayChargeDate;
const advanceByPeriodWhile = (date, period, shouldAdvance) => (shouldAdvance(date) ? advanceByPeriodWhile(date.plus(period), period, shouldAdvance) : date);
